import "./toaster.controller";
import { auth } from "../../typings/auth";
import { thor } from "../../typings/thor";

interface MaterialToasterParameters {
    template: string;
    position: string;
    hideDelay: number;
    controller: string;
    controllerAs: string;
    locals;
    toastClass;
    values;
}

class ToasterService {
    public static $inject: string[] = [
        "$log",
        "$mdToast",
        "$translate",
        "sitesService"
    ];

    private $t;

    constructor(
        private $log: ng.ILogService,
        private $mdToast: ng.material.IToastService,
        $translate: ng.translate.ITranslateService,
        private sitesService
    ) {
        this.$t = $translate.instant;
    }

    public toastContactEmailBusiness(scope: auth.Scopes = auth.Scopes.BA_ACCESS) {
        let message;

        switch (scope) {
            case auth.Scopes.BA_ACCESS:
            default:
                message = "l_acces_a_la_base_d_adjudication_est_bloque_veuillez_contacter_le_service_commercial";
                break;
        }

        return this.translate({
            message,
            values: {
                contacter_le_service_commercial: `<a ng-href=\"mailto:${this.sitesService.contactEmailBusiness}\">${
                    this.$t("contacter_le_service_commercial")
                }</a>`
            },
            warn: true
        });
    }

    public toastContactSupport(
        scope: auth.Scopes = auth.Scopes.ORGANIZATION_CLIENT_INFORMATIONS,
        warn: boolean = true
    ) {
        const {
            contactSupport: { email, tel, tel_link }
        } = this.sitesService;
        let message;

        switch (scope) {
            case auth.Scopes.PAYOUTS:
                message = "l_acces_au_suivi_des_paiements_est_bloque_veuillez_contacter_l_equipe_support_au";
                break;
            case auth.Scopes.ORGANIZATION_CLIENT_INFORMATIONS:
            default:
                message = "sale.toaster_support";
                break;
        }

        return this.translate({
            message,
            values: {
                email: `<a ng-href=\"mailto:${email}\">${email}</a>`,
                tel: `<a ng-href=\"${tel_link}\">${tel}</a>`
            },
            warn
        });
    }

    public toastPremiumOnSaleStartedOrInLessThan48hours(saleStarted: boolean) {
        const email = this.sitesService.contactEmailBusiness;

        return this.translate({
            message: saleStarted ? "toaster_premium.sale_started" : "toaster_premium.sale_in_less_than_48_hours",
            values: {
                // tslint:disable-next-line:max-line-length
                // workaround https://stackoverflow.com/questions/8549816/open-the-href-mailto-link-in-new-tab-window/9880404#988040
                email: `<a onClick="javascript:window.open('mailto:${email}', 'mail');event.preventDefault()" href="mailto:${email}">${email}</a>`
            },
            warn: true
        });
    }

    public toastQuotasContactEmailBusiness(warn?: boolean) {
        const { contactEmailBusiness: mailto } = this.sitesService;

        return this.translate({
            message: `${ warn ? "vous_avez_atteint_la_limite_de_ventes_dans_votre_forfait_" : ""
                }contactez_le_service_commercial_pour_augmenter_votre_nombre_de_ventes`,
            values: {
                contactez_le_service_commercial: `<a ng-href=\"mailto:${mailto}\">${
                    this.$t("contactez_le_service_commercial")}</a>`
            },
            warn
        });
    }

    public toast(parameters: thor.ToasterParameter) {
        this.checkParameters(parameters);

        const toasterParameters: MaterialToasterParameters = {
            template: parameters.template || require("./toaster.html"),
            locals: { message: parameters.message, hideCloseButton: parameters.hideCloseButton },
            toastClass: parameters.warn ? "warn" : null,
            position: parameters.position || "bottom left",
            controller: "ToasterController",
            controllerAs: "toasterCtrl",
            hideDelay: parameters.delay || 0,
            values: parameters.values || null
        };

        return this.$mdToast.show(toasterParameters);
    }

    public show(message: string, warn: boolean = false, delay: number = 4000) {
        this.toast({
            message,
            warn,
            delay
        });
    }

    public translate(parameters: thor.ToasterParameter) {
        parameters.template = require("./toaster-translate.html");
        this.toast(parameters);
    }

    private checkParameters(parameters) {
        const errors = [];

        if (typeof parameters !== "object") {
            errors.push("Not an object passed in parameter");
        }
        if (!parameters.message) {
            errors.push("No message specified");
        }
        if (parameters.delay !== undefined && !angular.isNumber(parameters.delay)) {
            errors.push("Delay parameter must be a number");
        }

        if (errors.length > 0) {
            this.$log.error("Toaster:", errors.join(".\n"));
            throw new Error("Toaster: " + errors.join(".\n"));
        }
    }
}

angular
    .module("thor.core.toaster.service", [
        "thor.core.toaster.controller"
    ])
    .service("toaster", ToasterService);
